export default "__VITE_ASSET__D$Y9EcdC__"